import * as React from 'react';

import { cn } from '@/lib/utils';

// forwardRef is REQUIRED, not cosmetic: react-hook-form's `register()`
// drives uncontrolled inputs by attaching a ref to read their value at
// submit time. A plain function component silently drops the ref (React
// strips `ref` from props for non-forwardRef components), so RHF never
// sees the value and the field validates as empty — which is exactly the
// bug that broke the admin CustomerCreate form (every field reported
// "Required" despite the DOM holding the typed value). Controlled
// usages (`{...field}` with a `value` prop) happened to work because RHF
// reads those off the value prop, masking the gap until the
// register()-based admin form was first exercised end-to-end.
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        data-slot="input"
        ref={ref}
        className={cn(
          'h-8 w-full min-w-0 rounded-lg border border-input bg-transparent px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
